import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=9e976cde&scoped=true&"
import script from "./BaseDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=9e976cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e976cde",
  null
  
)

export default component.exports